import React from 'react';
import clone from 'clone';

import {CustomScrollbarTrackVisibility as CustomScrollbarTrackVisibility_, CustomScrollbarProps as CustomScrollbarProps_} from './custom-scrollbar-model';
import CustomScrollbarHelper from './custom-scrollbar-helper';
import OEToolbox from '../tools/oe-toolbox-core';
import OEResizeObserver from '../components/oe-resize-observer';
import retardUpdate from '../react/update-retarder';

export const CustomScrollbarTrackVisibility = CustomScrollbarTrackVisibility_;
export const CustomScrollbarProps = CustomScrollbarProps_;

export default class CustomScrollbar extends React.PureComponent {
    
    constructor(props, ...rest) {
        super(props, ...rest);

        this.debugOut = false;

        this.unitSize = 16;

        this.autoHide = false;

        this.viewParams = CustomScrollbarHelper.getViewParams(this);
        this.horizontalParams = CustomScrollbarHelper.getHorizontalParams(this);
        this.verticalParams = CustomScrollbarHelper.getVerticalParams(this);

        this.className = CustomScrollbarHelper.getClassName(this);
        this.viewStyle = CustomScrollbarHelper.getViewStyle(this);
        this.horizontalTrackStyle = CustomScrollbarHelper.getHorizontalTrackStyle(this);
        this.verticalTrackStyle = CustomScrollbarHelper.getVerticalTrackStyle(this);
        this.horizontalThumbStyle = CustomScrollbarHelper.getHorizontalThumbStyle(this);
        this.verticalThumbStyle = CustomScrollbarHelper.getVerticalThumbStyle(this);
        this.trackGapStyle = CustomScrollbarHelper.getTrackGapStyle(this)

        this.state = {
            className: this.className,
            viewStyle: clone(this.viewStyle),
            horizontalTrackStyle: clone(this.horizontalTrackStyle),
            verticalTrackStyle: clone(this.verticalTrackStyle),
            horizontalThumbStyle: clone(this.horizontalThumbStyle),
            verticalThumbStyle: clone(this.verticalThumbStyle),
            trackGapStyle: clone(this.trackGapStyle)
        };

        this.scrollCompletedFNs = [];

        this.noScrollStartCallScrollCompletedFNs = this.noScrollStartCallScrollCompletedFNs.bind(this);

        this.onWindowResized = this.onWindowResized.bind(this);

        this.onMouseMove = this.onMouseMove.bind(this);
        this.onScroll = this.onScroll.bind(this);
        this.onHorizontalTrackMouseDown = this.onHorizontalTrackMouseDown.bind(this);
        this.onVerticalTrackMouseDown = this.onVerticalTrackMouseDown.bind(this);
        this.onHorizontalThumbMouseDown = this.onHorizontalThumbMouseDown.bind(this);
        this.onVerticalThumbMouseDown = this.onVerticalThumbMouseDown.bind(this);
        this.onDrag = this.onDrag.bind(this);
        this.onDragEnd = this.onDragEnd.bind(this);

        this.onRef = this.onRef.bind(this);
        this.onViewRef = this.onViewRef.bind(this);
        this.onHorizontalTrackRef = this.onHorizontalTrackRef.bind(this);
        this.onVerticalTrackRef = this.onVerticalTrackRef.bind(this);
        this.onHorizontalThumbRef = this.onHorizontalThumbRef.bind(this);
        this.onVerticalThumbRef = this.onVerticalThumbRef.bind(this);

        this.onUnitSizeResize = this.onUnitSizeResize.bind(this);
        this.onResize = this.onResize.bind(this);
        this.onContentResize = this.onContentResize.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        let needsHUpdate = false, needsVUpdate = false;

        if(nextProps.autoUpdate !== this.props.autoUpdate && nextProps.autoUpdate) {
            needsHUpdate = needsVUpdate = true;
        }

        if(nextProps.horizontalTrackVisiblity !== this.props.horizontalTrackVisiblity) needsHUpdate = true;

        if(nextProps.verticalTrackVisiblity !== this.props.verticalTrackVisiblity) needsVUpdate = true;

        if(needsHUpdate)    {
            if(needsVUpdate)    {
                this.updateHVParams(nextProps);
            } else {
                this.updateHorizontalParams(nextProps);
            }
        } else if(needsVUpdate) {
            this.updateVerticalParams(nextProps);
        }

        if(nextProps.className !== this.props.className)    {
            this.updateClassName(nextProps);
        }

        if(nextProps.autoHide !== this.props.autoHide)  {
            if(nextProps.autoHide && this.ref)  this.ref.addEventListener('mousemove', this.onMouseMove);
            this.setAutoHideCycle(nextProps);
        }
    }

    componentWillMount()    {
        if(this.props.onHorizontalParamsChanged)    this.props.onHorizontalParamsChanged(this, this.horizontalParams);
        if(this.props.onVerticalParamsChanged)      this.props.onVerticalParamsChanged(this, this.verticalParams);
    }

    componentDidMount()    {
        this.mounted = true;
        this.update();
        this.setAutoHideCycle();
        window.addEventListener('resize', this.onWindowResized);
    }

    componentWillUnmount()    {
        this.endDrag();
        this.endTrackScrolling();
        this.callScrollCompletedFNs();
        this.clearAutoHideCycle();
        window.removeEventListener('resize', this.onWindowResized);
        this.mounted = false;

        if(this.props.onHorizontalParamsChanged)    this.props.onHorizontalParamsChanged(this, CustomScrollbarHelper.getHorizontalParams2());
        if(this.props.onVerticalParamsChanged)      this.props.onVerticalParamsChanged(this, CustomScrollbarHelper.getVerticalParams2());
    }

    componentDidUpdate()    {
        this.updateHVParams();
    }

    onWindowResized()   {
        this.update();
    }

    callScrollCompletedFNs()    {
        if(!this.scrollCompletedFNs.length) return;

        let scrollCompletedFNs = this.scrollCompletedFNs;
        this.scrollCompletedFNs = [];
        
        scrollCompletedFNs.forEach(fn => {
            fn(this, true);
        });
    }

    noScrollStartCallScrollCompletedFNs()   {
        if(!this.isScrolling)  this.callScrollCompletedFNs();
    }

    getElementRef() {
        return this.ref;
    }

    getScrollElementRef()   {
        return this.viewRef;
    }

    getScrollLeft() {
        return this.viewRef ? this.viewRef.scrollLeft : 0;
    }

    getScrollTop() {
        return this.viewRef ? this.viewRef.scrollTop : 0;
    }

    getScrollWidth() {
        return this.viewRef ? this.viewRef.scrollWidth : 0;
    }

    getScrollHeight() {
        return this.viewRef ? this.viewRef.scrollHeight : 0;
    }

    getClientWidth() {
        return this.viewRef ? this.viewRef.clientWidth : 0;
    }

    getClientHeight() {
        return this.viewRef ? this.viewRef.clientHeight : 0;
    }

    scrollLeft(left = 0, completed) {
        if(!this.viewRef)   {
            if(completed)   completed(this, false);
            return;
        }
        
        if(completed)   this.scrollCompletedFNs.push(completed);

        this.viewRef.scrollLeft = left;

        window.requestAnimationFrame(this.noScrollStartCallScrollCompletedFNs);
    }

    scrollTop(top = 0, completed) {
        if(!this.viewRef)   {
            if(completed)   completed(this, false);
            return;
        }

        if(completed)   this.scrollCompletedFNs.push(completed);

        this.viewRef.scrollTop = top;

        window.requestAnimationFrame(this.noScrollStartCallScrollCompletedFNs);
    }

    scrollToLeft(completed) {
        this.scrollLeft(0, completed);
    }

    scrollToTop(completed) {
        this.scrollTop(0, completed);
    }

    scrollToRight(completed) {
        this.scrollLeft(this.viewRef ? this.viewRef.scrollWidth : 0, completed);
    }

    scrollToBottom(completed) {
        this.scrollTop(this.viewRef ? this.viewRef.scrollHeight : 0, completed);
    }

    clearAutoHideCycle()    {
        if(this.autoHideInterval) {
            clearInterval(this.autoHideInterval);
            this.autoHideInterval = undefined;
        }
    }

    setAutoHideCycle(props)    {
        props = props || this.props;
        this.clearAutoHideCycle();

        if(!this.mounted)   return;

        if(!props.autoHide) {
            this.setAutoHide(false);
            return;
        }

        this.autoHideInterval = setInterval(() => {
            if(this.isScrolling || this.isDragging)   return;
            this.setAutoHide(true);
            this.clearAutoHideCycle();
        }, props.autoHideTimeout);

        this.setAutoHide(false);
    }

    setAutoHide(hide)   {
        if(this.autoHide == hide)   return;
        this.autoHide = hide;
        this.onAutoHideChanged();
    }

    updateViewParams(props)  {
        if(!this.mounted)   return;
        // dep: scrollbar size
        let params = CustomScrollbarHelper.getViewParams(this, props);
        if(OEToolbox.shallowEqual(params, this.viewParams, true))   return;
        this.viewParams = params;
        this.onViewParamsChanged();
    }

    updateHorizontalParams(props)  {
        if(!this.mounted)   return;
        // dep: viewRef, horizontalTrackRef, props.thumbSize, props.minThumbSize, props.horizontalTrackVisiblity
        let params = CustomScrollbarHelper.getHorizontalParams(this, props);
        if(OEToolbox.shallowEqual(params, this.horizontalParams, true))   return;
        this.horizontalParams = params;
        this.onHorizontalParamsChanged();
    }

    updateVerticalParams(props)  {
        if(!this.mounted)   return;
        // dep: viewRef, verticalTrackRef, props.thumbSize, props.minThumbSize, props.verticalTrackVisiblity
        let params = CustomScrollbarHelper.getVerticalParams(this, props);
        if(OEToolbox.shallowEqual(params, this.verticalParams, true))   return;
        this.verticalParams = params;
        this.onVerticalParamsChanged();
    }

    updateClassName(props)  {
        if(!this.mounted)   return;
        let className = CustomScrollbarHelper.getClassName(this, props);
        if(className === this.className)    return;
        this.className = className;
        this.setState({className: className});
    }

    updateHorizontalTrackStyle()    {
        if(!this.mounted)   return;
        let style = CustomScrollbarHelper.getHorizontalTrackStyle(this);
        if(!OEToolbox.shallowEqual(style, this.horizontalTrackStyle, true))    {
            this.horizontalTrackStyle = style;
            this.setState({horizontalTrackStyle: clone(style)});
        }
    }

    updateVerticalTrackStyle()    {
        if(!this.mounted)   return;
        let style = CustomScrollbarHelper.getVerticalTrackStyle(this);
        if(!OEToolbox.shallowEqual(style, this.verticalTrackStyle, true))    {
            this.verticalTrackStyle = style;
            this.setState({verticalTrackStyle: clone(style)});
        }
    }

    updateHorizontalThumbStyle()    {
        if(!this.mounted)   return;
        let style = CustomScrollbarHelper.getHorizontalThumbStyle(this);
        if(!OEToolbox.shallowEqual(style, this.horizontalThumbStyle, true))    {
            this.horizontalThumbStyle = style;
            this.setState({horizontalThumbStyle: clone(style)});
        }
    }

    updateVerticalThumbStyle()  {
        if(!this.mounted)   return;
        let style = CustomScrollbarHelper.getVerticalThumbStyle(this);
        if(!OEToolbox.shallowEqual(style, this.verticalThumbStyle, true))    {
            this.verticalThumbStyle = style;
            this.setState({verticalThumbStyle: clone(style)});
        }
    }

    updateTrackGapStyle()  {
        if(!this.mounted)   return;
        let style = CustomScrollbarHelper.getTrackGapStyle(this);
        if(!OEToolbox.shallowEqual(style, this.trackGapStyle, true))    {
            this.trackGapStyle = style;
            this.setState({trackGapStyle: clone(style)});
        }
    }

    updateHVParams(props)   {
        if(!this.mounted)   return;
        retardUpdate(this, () => {
            this.updateHorizontalParams(props);
            this.updateVerticalParams(props);
        });
    }

    update(props)    {
        if(!this.mounted)   return;
        retardUpdate(this, () => {
            this.updateViewParams(props);
            this.updateHorizontalParams(props);
            this.updateVerticalParams(props);
            this.updateClassName(props);
            this.updateTrackGapStyle();
        });
    }

    onAutoHideChanged() {
        if(!this.mounted)   return;

        retardUpdate(this, () => {
            this.updateHorizontalTrackStyle();
            this.updateVerticalTrackStyle();
            this.updateTrackGapStyle();
        });
    }

    onViewParamsChanged()   {
        if(!this.mounted)   return;

        let style = CustomScrollbarHelper.getViewStyle(this);
        if(OEToolbox.shallowEqual(style, this.viewStyle, true))   return;
        this.viewStyle = style;
        this.setState({viewStyle: clone(style)});
    }

    onHorizontalParamsChanged()   {
        if(!this.mounted)   return;

        retardUpdate(this, () => {
            this.updateClassName();
            this.updateHorizontalTrackStyle();
            this.updateHorizontalThumbStyle();
        });

        if(this.props.onHorizontalParamsChanged)    this.props.onHorizontalParamsChanged(this, this.horizontalParams);
    }

    onVerticalParamsChanged()   {
        if(!this.mounted)   return;

        retardUpdate(this, () => {
            this.updateClassName();
            this.updateVerticalTrackStyle();
            this.updateVerticalThumbStyle();
        });

        if(this.props.onVerticalParamsChanged)    this.props.onVerticalParamsChanged(this, this.verticalParams);
    }

    onMouseMove(event)  {
        this.setAutoHideCycle();
    }

    onScroll(event) {
        if(!this.mounted)   return;

        this.update();

        this.startTrackScrolling();

        this.setAutoHideCycle();

        if(this.props.onScroll) this.props.onScroll(this);

        if(this.debugOut)   console.log('onScroll - ' + this.getScrollLeft() + ' - ' + this.getScrollTop());
    }

    onHorizontalTrackMouseDown(event) {
        event.preventDefault();
        if(!this.viewRef)   return;

        const targetLeft = event.target.getBoundingClientRect().left;
        const thumbSize = CustomScrollbarHelper.getHorizontalThumbWidth(this);
        const offset = Math.abs(targetLeft - event.clientX) - thumbSize / 2;

        this.viewRef.scrollLeft = CustomScrollbarHelper.getScrollLeftForOffset(this, offset);

        this.setAutoHideCycle();
    }

    onVerticalTrackMouseDown(event) {
        event.preventDefault();
        if(!this.viewRef)   return;

        const targetTop = event.target.getBoundingClientRect().top;
        const thumbSize = CustomScrollbarHelper.getVerticalThumbHeight(this);
        const offset = Math.abs(targetTop - event.clientY) - thumbSize / 2;

        this.viewRef.scrollTop = CustomScrollbarHelper.getScrollTopForOffset(this, offset);

        this.setAutoHideCycle();
    }

    onHorizontalThumbMouseDown(event) {
        if(this.isDragging)   return;
        event.preventDefault();
        event.stopImmediatePropagation();
        this.startDrag();
        this.mouseThumbOffsetX = event.clientX - event.target.getBoundingClientRect().left;
    }

    onVerticalThumbMouseDown(event) {
        if(this.isDragging)   return;
        event.preventDefault();
        event.stopImmediatePropagation();
        this.startDrag();
        this.mouseThumbOffsetY = event.clientY - event.target.getBoundingClientRect().top;
    }

    startDrag() {
        this.isDragging = true;
        document.addEventListener('mousemove', this.onDrag);
        document.addEventListener('mouseup', this.onDragEnd);
        document.onselectstart = () => false;

        this.setAutoHideCycle();
    }

    endDrag()   {
        this.isDragging = false;
        document.removeEventListener('mousemove', this.onDrag);
        document.removeEventListener('mouseup', this.onDragEnd);
        document.onselectstart = undefined;
        this.mouseThumbOffsetX = this.mouseThumbOffsetY = undefined;
    }

    onDrag(event)   {
        if(!this.viewRef)   return false;
        
        if(typeof(this.mouseThumbOffsetX) === 'number') {
            if(!this.horizontalTrackRef)    return;

            const offset = event.clientX - this.horizontalTrackRef.getBoundingClientRect().left - this.mouseThumbOffsetX;
            this.viewRef.scrollLeft = CustomScrollbarHelper.getScrollLeftForOffset(this, offset);
        }

        if(typeof(this.mouseThumbOffsetY) === 'number') {
            if(!this.verticalTrackRef)    return;

            const offset = event.clientY - this.verticalTrackRef.getBoundingClientRect().top - this.mouseThumbOffsetY;
            this.viewRef.scrollTop = CustomScrollbarHelper.getScrollTopForOffset(this, offset);
        }

        return false;
    }

    onDragEnd(event)    {
        this.endDrag();
    }

    endTrackScrolling() {
        if(!this.isScrolling || !this.mounted)    return;
        this.isScrolling = false;

        if(this.trackScrollingInterval) {
            clearInterval(this.trackScrollingInterval);
            this.trackScrollingInterval = undefined;
        }

        this._lastScrollLeft = undefined;
        this._lastScrollTop = undefined;

        this.onScrollEnd();
    }

    startTrackScrolling()    {
        if(this.isScrolling || !this.mounted)    return;
        this.isScrolling = true;
        
        this.onScrollStart();

        this.trackScrollingInterval = setInterval(() => {
            const scrollLeft = this.getScrollLeft(), scrollTop = this.getScrollTop();

            if(this._lastScrollLeft != scrollLeft || this._lastScrollTop != scrollTop)  {
                this._lastScrollLeft = scrollLeft;
                this._lastScrollTop = scrollTop;
                return;
            }

            this.endTrackScrolling();
        }, 100);
    }

    onScrollStart() {
        this.setAutoHideCycle();

        if(this.props.onScrollStart) this.props.onScrollStart(this);

        if(this.debugOut)   console.log('onScrollStart - ' + this.getScrollLeft() + ' - ' + this.getScrollTop());
    }

    onScrollEnd()   {
        if(this.props.onScrollEnd) this.props.onScrollEnd(this);

        this.callScrollCompletedFNs();

        if(this.debugOut)   console.log('onScrollEnd - ' + this.getScrollLeft() + ' - ' + this.getScrollTop());
    }

    onRef(ref)  {
        if(this.ref == ref) return;
        if(this.ref)    this.ref.removeEventListener('mousemove', this.onMouseMove);
        this.ref = ref;
        if(this.props.autoHide && this.ref)    this.ref.addEventListener('mousemove', this.onMouseMove);

        if(this.props.elementRef)   this.props.elementRef(ref);
    }

    onViewRef(ref)  {
        if(this.viewRef == ref) return;
        if(this.viewRef)    this.viewRef.removeEventListener('scroll', this.onScroll);
        this.viewRef = ref;
        if(this.viewRef)    this.viewRef.addEventListener('scroll', this.onScroll);

        this.updateHVParams();

        if(this.props.scrollElementRef)   this.props.scrollElementRef(ref);
    }

    onHorizontalTrackRef(ref)  {
        if(this.horizontalTrackRef == ref) return;
        if(this.horizontalTrackRef) this.horizontalTrackRef.removeEventListener('mousedown', this.onHorizontalTrackMouseDown);
        this.horizontalTrackRef = ref;
        if(this.horizontalTrackRef) this.horizontalTrackRef.addEventListener('mousedown', this.onHorizontalTrackMouseDown);

        this.updateHorizontalParams();
    }

    onVerticalTrackRef(ref)  {
        if(this.verticalTrackRef == ref) return;
        if(this.verticalTrackRef)   this.verticalTrackRef.removeEventListener('mousedown', this.onVerticalTrackMouseDown);
        this.verticalTrackRef = ref;
        if(this.verticalTrackRef)   this.verticalTrackRef.addEventListener('mousedown', this.onVerticalTrackMouseDown);

        this.updateVerticalParams();
    }

    onHorizontalThumbRef(ref)  {
        if(this.horizontalThumbRef == ref) return;
        if(this.horizontalThumbRef) this.horizontalThumbRef.removeEventListener('mousedown', this.onHorizontalThumbMouseDown);
        this.horizontalThumbRef = ref;
        if(this.horizontalThumbRef) this.horizontalThumbRef.addEventListener('mousedown', this.onHorizontalThumbMouseDown);
    }

    onVerticalThumbRef(ref)  {
        if(this.verticalThumbRef == ref) return;
        if(this.verticalThumbRef) this.verticalThumbRef.removeEventListener('mousedown', this.onVerticalThumbMouseDown);
        this.verticalThumbRef = ref;
        if(this.verticalThumbRef) this.verticalThumbRef.addEventListener('mousedown', this.onVerticalThumbMouseDown);
    }

    renderContent() {
        const resizeObserver = this.props.autoUpdate || this.props.onContentResize ? <OEResizeObserver onResize={this.onContentResize}/> : null;

        return this.props.bare ? (
            <React.Fragment>
                {resizeObserver}
                {this.props.children}
            </React.Fragment>
        ) : (
            <div className="custom-scrollbar-content">
                {resizeObserver}
                {this.props.children}
            </div>
        );
    }

    render() {

        return (
            <div
                className={this.state.className}
                style={this.props.style}
                ref={this.onRef}
            >
                <OEResizeObserver className="unit-size-observer" onResize={this.onUnitSizeResize}/>

                {!this.props.autoUpdate && !this.props.onResize ? null :
                    <OEResizeObserver onResize={this.onResize}/>
                }

                <div
                    className="custom-scrollbar-view"
                    style={this.state.viewStyle}
                    ref={this.onViewRef}
                >
                    {this.renderContent()}
                </div>

                <div
                    className="track-gap track-bg"
                    style={this.state.trackGapStyle}
                />

                <div
                    className="track-horizontal track-bg"
                    style={this.state.horizontalTrackStyle}
                    ref={this.onHorizontalTrackRef}
                >
                    <div
                        className="thumb-horizontal thumb-bg"
                        style={this.state.horizontalThumbStyle}
                        ref={this.onHorizontalThumbRef}
                    />
                </div>

                <div
                    className="track-vertical track-bg"
                    style={this.state.verticalTrackStyle}
                    ref={this.onVerticalTrackRef}
                >
                    <div
                        className="thumb-vertical thumb-bg"
                        style={this.state.verticalThumbStyle}
                        ref={this.onVerticalThumbRef}
                    />
                </div>

            </div>
        );
    }

    onUnitSizeResize(sender, size)  {
        if(this.unitSize === size.w) return;
        this.unitSize = size.w;
        this.update();
    }

    onResize(sender, size)   {
        if(this.props.autoUpdate)   this.update();
        if(this.props.onResize)  this.props.onResize(this, size);
    }

    onContentResize(sender, size)   {
        if(this.props.autoUpdate)   this.update();
        if(this.props.onContentResize)  this.props.onContentResize(this, size);
    }
}

CustomScrollbar.defaultProps = CustomScrollbarProps.defaultProps;

CustomScrollbar.propTypes = CustomScrollbarProps.propTypes;